import { DtapiReportDisplayValues, GlideReportDisplayValues, ParcelProviderType, PropertyReport } from 'types';

export const getLatestReportByProvider = (reports: PropertyReport[], provider: ParcelProviderType) => {
  const providerReports = reports.filter((report) => report.parcelProvider === provider);
  if (!providerReports.length) return null;

  return providerReports.reduce((latest, current) =>
    new Date(current.createdAt).getTime() > new Date(latest.createdAt).getTime() ? current : latest,
  );
};

export const getGlideRows = (report: GlideReportDisplayValues) => {
  const attributes = report?.response?.Reports?.[0]?.Data?.attributes;
  if (!attributes) return null;

  return [
    { label: 'Zoning Description', value: attributes.zoning_description ?? 'Not found' },
    { label: 'LBCS Structure Description', value: attributes.lbcs_structure_desc ?? 'Not found' },
    { label: 'LBCS Activity Description', value: attributes.lbcs_activity_desc ?? 'Not found' },
    { label: 'Zoning Type', value: attributes.zoning_type ?? 'Not found' },
    { label: 'Number of Stories', value: attributes.numstories ?? 'Not found' },
  ];
};

export const getDtapiRows = (report: DtapiReportDisplayValues) => {
  const values = report?.response?.Reports?.[0]?.Data;
  if (!values || values.message) return null;

  return [
    { label: 'Land Use', value: values.SiteInformation?.LandUse ?? 'Not found' },
    { label: 'Residential Units', value: values.SiteInformation?.UnitsResidential ?? 'Not found' },
    { label: 'Number of Stories', value: values.PropertyCharacteristics?.NumberOfStories ?? 'Not found' },
  ];
};
